/*
 * @flow
 */
import axios from 'axios';
import * as globals from '../constants/globals';
import { makeAsyncAction } from '../utils/async_utils';
import { POST_REVIEW_VOTE_FAILURE, POST_REVIEW_VOTE_START, POST_REVIEW_VOTE_SUCCESS } from '../constants/types';

export type voteRequest = {
  reservation_id: string,
  is_helpful: boolean,
  vote_changed: boolean,
};

export const postReviewVoteEndpoint = () => `${globals.API_URL}/helpful/vote`;

const postReviewVoteApi = (data: voteRequest) => () => axios.post(postReviewVoteEndpoint(), data);

export const postReviewVote = makeAsyncAction(
  { startType: POST_REVIEW_VOTE_START, successType: POST_REVIEW_VOTE_SUCCESS, failureType: POST_REVIEW_VOTE_FAILURE },
  postReviewVoteApi,
  true,
  'data'
);
